import React, { Component } from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { MessageBars } from '../Outils/MessageBars';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { HintWrapper, HintVerticalPosition } from '../Outils/HintWrapper';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { ComboBoxSociete } from '../ComboBox/ComboBoxSociete';
import { ComboBoxCompte } from '../ComboBox/ComboBoxCompte';
import { DataLotCommercial } from '../../data/DataLotCommercial';
import { DataCommercialisateur } from '../../data/DataCommercialisateur';
import { DataMandat } from '../../data/DataMandat';

/****************************************************************
 PROPS:
    idOperation
    idLotCommercial
        Ne pas utiliser ça n'est plus vrai => idReservation => si renseigné on souhaite pointer directement sur la commercialisation liée à la réservation
    commercialisateur

    onAffichePanelCommercialisateur : bool

    onEnregistrementFiche : méthode
    onAnnuleFiche : méthode
    
    classname : classe CSS (string)
    classnameinner : classe CSS (string)

    afficheHonorairesPerso--> utilisé depuis la FicheOption


    //**********************
    //YD : 18/02/2020
    //ajout de :
    //idOperation={this.props.idOperation}
    //idLotCommercial={this.props.idLotCommercial}
    //afin de pouvoir filtrer la liste des sociétés qui ont un mandat sur le lot commercial

****************************************************************/

var objetState = {
    commercialisateur: {},
    mandat: {},

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',

    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',

    titrePanelCommercialisateur: 'Ajouter un commercialisateur',
};

export class FicheCommercialisateur extends Component {
    _creationContent() {
        return (
            <Panel
                closeButtonAriaLabel="Fermer"
                headerText={this.state.titrePanelCommercialisateur}
                isOpen={this.props.onAffichePanelCommercialisateur}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                onRenderFooterContent={this._onRenderFooterContent}
                type={PanelType.medium}
            >
                <div className={this.props.classname}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            <div className="ms-Grid-row">
                                <div name="divSocieteCommercialisateur" className="ms-Grid-col ms-sm12">
                                    <HintWrapper
                                        content={<span>Sélectionner une société de commercialisation puis au sein de cette société un commercialisateur. Si vous ne trouvez pas la société ou le commercialisateur, appelez votre gestionnaire de mandats pour mise à jour.</span>}
                                        verticalAlign={HintVerticalPosition.bottom}
                                        verticalOffset={5}
                                    >
                                        <ComboBoxSociete
                                            idLotCommercial={this.props.idLotCommercial}
                                            idOperation={this.props.idOperation}
                                            onChange={(event, option, index, value, item) => this._onChangeSociete(item.idSociete)}
                                            required
                                            selectedKey={this.state.commercialisateur.idSociete}
                                        />
                                    </HintWrapper>
                                </div>
                                <div name="divCommercialisateur" className="ms-Grid-col ms-sm12">
                                    <ComboBoxCompte
                                        avecValeurDefaut={false}
                                        disabled={!this.state.commercialisateur.idSociete}
                                        idLotCommercial={this.props.idLotCommercial}
                                        idOperation={this.props.idOperation}
                                        idSociete={this.state.commercialisateur.idSociete}
                                        idsTypesMandats={[2]}
                                        label="Commercialisateur"
                                        onChange={(event, option) => this._onChargementMandatCommercialisateurSelectionne(option.key)}
                                        required
                                        selectedKey={this.state.commercialisateur.loginCompte}
                                    />
                                </div>
                            </div>

                            {this.state.commercialisateur.loginCompte !== undefined && this.state.commercialisateur.loginCompte != null ?
                                <div className="ms-Grid-row">
                                    <div className="ms-Grid-col ms-sm12" style={{ marginTop: '10px' }}>
                                        <div>
                                            Honoraires commercialisation : {this.state.mandat.honoraireCommercialisation}
                                        </div>
                                        <div>
                                            Base de calcul : {this.state.mandat.baseCalculHonoraireCommercialisation}
                                        </div>
                                        <div>
                                            Exclusivité : {this.state.mandat.exclusivite ? "oui" : "non"}
                                        </div>
                                        <div>
                                            Honoraires contractuels HT : {Scriba.nombre().nombreVersTexteAvecPrecisionAfficheeSpecifiee(this.state.commercialisateur.honorairesContractuels, false, 2)} €
                                            </div>
                                    </div>

                                    {this.props.afficheHonorairesPerso ?
                                        <div className="ms-Grid-col ms-sm12" style={{ marginTop: '10px' }}>
                                            <TextField // Note KP : TextFieldNombre en cours de test
                                                label="Honoraires réels HT"
                                                required
                                                value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'commercialisateur', 'honoraireReelHT', false, 2)}
                                                onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'commercialisateur', 'honoraireReelHT')}
                                                onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'commercialisateur', 'honoraireReelHT', e.target.value)}
                                                onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'honoraireReelHT', e, false, 2)}
                                                deferredValidationTime={0}
                                                suffix="€"
                                            />
                                        </div>
                                        : null
                                    }
                                </div>
                                : null
                            }
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onChargementMandatCommercialisateurSelectionne(loginCompte) {
        if (loginCompte !== undefined && loginCompte != null) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Chargement du commercialisateur en cours'
            });

            //let onChargementMandatCommercialisateurSelectionne = DataCommercialisateur._onChargementMandatCommercialisateurSelectionne(loginCompte, this.props.idOperation, this.props.idLotCommercial);
            let onChargementMandatCommercialisateurSelectionne = DataMandat._chargementMandatCommercialisateurLePlusBasPourUnLotCommercial(this.props.idOperation, this.props.idLotCommercial, loginCompte);

            onChargementMandatCommercialisateurSelectionne
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        if (objetData != null) {
                            let commercialisateurTemp = { ...this.state.commercialisateur };
                            commercialisateurTemp.loginCompte = loginCompte;
                            commercialisateurTemp.idSociete = (objetData !== null ? objetData.idSociete : 0);

                            let stateTemp = {};
                            stateTemp.commercialisateur = commercialisateurTemp;
                            stateTemp.mandat = (objetData != null ? objetData : {});

                            //let stateTemp = {};
                            //stateTemp.commercialisateur.loginCompte = loginCompte;
                            //stateTemp.commercialisateur.idSociete = (objetData !== null ? objetData.idSociete : 0);
                            //stateTemp.mandat = (objetData != null ? objetData : {});

                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                            this._chargementLotCommercial();
                        }
                        else {
                            this.setState({
                                enCoursDeTraitement: false,
                                messageEnCoursTraitement: '',
                                hideMessageBarError: false,
                                errorMessage: 'Aucun mandat valide pour la société et le commercialisateur sélectionnés sur cette opération.'
                            });
                        }
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            Scriba.state().setObjetPropriete(this, "commercialisateur", "loginCompte", null);
        }
    }

    _chargementLotCommercial() {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du lot commercial'
        });

        let chargementLotCommercial = DataLotCommercial._chargementLotCommercial(this.props.idOperation, this.props.idLotCommercial);

        chargementLotCommercial
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
               
                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    let lotcommercial = objetData[1];
                    let tvaOperation = objetData[2];

                    if (tvaOperation !== undefined) {
                        let prixHT = lotcommercial.prixHT;
                        let tvaLot = tvaOperation.taux;
                        let prixTTCLot = prixHT * (1 + tvaLot);

                        // Calcul des honoraires
                        let mandatTrav = this.state.mandat;
                        let honorairesCalcules = 0;

                        if (mandatTrav.honoraireCommercialisation !== undefined && mandatTrav.honoraireCommercialisation != null) {

                            //MG - 25/05/2023 - 2335/2239
                            const result = Immocom.calculationHonoraireReel(mandatTrav.honoraireCommercialisation, mandatTrav.baseCalculHonoraireCommercialisation, prixTTCLot, prixHT);
                            honorairesCalcules = result !== undefined ? result.honoraireReel.toFixed(2) : 0;                           

                            let commercialisateurTemp = { ...this.state.commercialisateur };
                            commercialisateurTemp.honoraireReelHT = honorairesCalcules;
                            commercialisateurTemp.honorairesContractuels = honorairesCalcules;

                            let stateTemp = {};
                            stateTemp.commercialisateur = commercialisateurTemp;

                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                        }
                        else {
                            this.setState({
                                enCoursDeTraitement: false,
                                messageEnCoursTraitement: '',
                                hideMessageBarWarning: false,
                                warningMessage: 'Aucun honoraire renseigné'
                            });
                        }
                    }
                    else {
                        this.setState({
                            enCoursDeTraitement: false,
                            messageEnCoursTraitement: '',
                            hideMessageBarWarning: false,
                            warningMessage: 'Aucune TVA renseignée pour cette opération'
                        });
                    }
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _validationFormulaire(item) {
        let estValide = true;

        // Si l'objet n'est pas vide
        if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
            estValide = estValide && (item.idSociete > 0);
            estValide = estValide && Scriba.formulaire().nEstPasVide(item.loginCompte);
            estValide = estValide && Scriba.nombre().nombreEstValide(item.honoraireReelHT, false, false, 2);
            estValide = estValide && Scriba.formulaire().nEstPasVide(item.honoraireReelHT);
        }
        else {
            estValide = false;
        }

        return estValide;
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du commercialisateur en cours'
        });

        let chargementCommercialisateurTemporaire = DataCommercialisateur._chargementCommercialisateurTemporaire(this.state.commercialisateur.loginCompte, this.state.commercialisateur.honoraireReelHT);

        chargementCommercialisateurTemporaire
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onEnregistrementFiche(objetData);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onOpen = () => {
        const idOperationRenseigne = Immocom.getSiPropsRenseignee(this.props.idOperation);
        const idLotCommercialRenseigne = Immocom.getSiPropsRenseignee(this.props.idLotCommercial);
        const commercialisateurRenseigne = Immocom.getSiPropsRenseignee(this.props.commercialisateur);

        if (idOperationRenseigne && idLotCommercialRenseigne && commercialisateurRenseigne)
            this._onChargementMandatCommercialisateurSelectionne(this.state.commercialisateur.loginCompte);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onAnnuleFiche();
    }

    _onChangeSociete = (key) => { // Mise à jour du state et réinitialisation de la ComboBoxCompte
        this.setState(prevState => ({
            commercialisateur: {
                ...prevState.commercialisateur,
                idSociete: key,
                loginCompte: null
            }
        }));
    };

    _onRenderFooterContent = () => {
        let boutonActif = this._validationFormulaire(this.state.commercialisateur);

        return (
            <div>
                <PrimaryButton name="buttonEnregistrerCommecialisateur" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Annuler</DefaultButton>
            </div>
        );
    };

    componentDidMount() { }

    componentDidUpdate() { }

    render() {
        return this._creationContent();
    }
}